import $ from 'jquery';
import 'what-input';
import 'jquery-ui';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.

window.$ = $;
window.jQuery = $;
require('foundation-sites');
require('jquery-editable-select');
require('owl.carousel');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
// import './lib/foundation-explicit-pieces';

$(document).foundation();

function mapResize() {
    var documentHeight = $(window).height();
    var headerHeight = $('#header').outerHeight();
    $('.gis-map').css('height', documentHeight - headerHeight);
    $('.tabs-content-gis').css('height', documentHeight - headerHeight);
}

function homeMapResize() {
    var documentHeight = $(window).height();
    var headerHeight = $('#header').outerHeight();
    var agriculturalWeatherHeight = $(".agricultural-weather").outerHeight();
    $('.agricultural-weather-map').css('height', documentHeight - headerHeight - agriculturalWeatherHeight);
    console.log(headerHeight);
    console.log(agriculturalWeatherHeight);
}

$(document).ready(function () {
    mapResize();
    $('#editable-select').editableSelect();
    var owl = $('.owl-carousel');
    owl.owlCarousel({
        loop: false,
        autoplayTimeout: 5000,
        nav: false,
        dots: false,
        // autoplay:true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1024: {
                items: 4
            },
            1440: {
                items: 7
            }
        }
    })

    $('.customNextBtn').click(function () {
        owl.trigger('next.owl.carousel');
    })
    // Go to the previous item
    $('.customPrevBtn').click(function () {
        // With optional speed parameter
        // Parameters has to be in square bracket '[]'
        owl.trigger('prev.owl.carousel', [300]);
    })
    $(window).resize(function () {
        mapResize();
    });
    
    if (Foundation.MediaQuery.is('small only')) {
        homeMapResize();
      }



      $('#editable-select-1').editableSelect();

});
